module.exports = __webpack_public_path__ + "static/img/jp2.7e74b799.png";